/* BCB deferred scripts.
 *
 * Carried over from the previous theme (v3, 17 Aug 2026) minus two blocks:
 *   - the PDP wholesale CTA, removed 17 Aug 2026 after wholesale_cta_click came
 *     in at 38 against 1,980 wholesale_page_view; the snippet link below the
 *     buy box already covers that path
 *   - the Shopify Inbox reveal delay, since Inbox is not installed on this theme
 *
 * The wholesale block used to be unreachable: the old theme loaded this file on
 * the product template only, so the /pages/wholesale events never fired from
 * here. Loaded on page templates too now.
 */

(function () {
  'use strict';

  /* Frequently Bought Together ships with Gift Wrapping pre-selected, which
   * silently adds a charge the shopper did not choose. */
  function uncheckGiftWrap() {
    document.querySelectorAll('.cbb-frequently-bought-selector-input').forEach(function (cb) {
      var label = cb.getAttribute('aria-label');
      if (label && label.toLowerCase().indexOf('gift wrapping') !== -1 && cb.checked) {
        cb.checked = false;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  var giftWrapTimer = setInterval(function () {
    if (document.querySelector('.cbb-frequently-bought-selector-input')) {
      clearInterval(giftWrapTimer);
      uncheckGiftWrap();
    }
  }, 300);
  setTimeout(function () { clearInterval(giftWrapTimer); }, 10000);

  /* GA4 events for the wholesale funnel, read by GTM. */
  if (location.pathname === '/pages/wholesale') {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'wholesale_page_view',
        event_category: 'engagement',
        page_path: '/pages/wholesale'
      });
    } catch (e) {}

    var form = document.querySelector('#ws-form form');
    if (form) {
      form.addEventListener('submit', function () {
        try {
          var type = document.getElementById('ws-type');
          var vol = document.getElementById('ws-volume');
          window.dataLayer.push({
            event: 'wholesale_inquiry_submit',
            event_category: 'lead',
            wholesale_business_type: type ? type.value : '',
            wholesale_volume: vol ? vol.value : ''
          });
        } catch (e) {}
      });
    }
  }
})();
